import { Button } from "@mui/material";
import { Box } from "@mui/material";
import { Divider } from "@mui/material";
import { FC } from "react";
import { LineItemDto, QuoteDto } from "../../../dtos";
import { QuoteLineItemsOrderView } from "../../../Views";

export interface IQuoteLineItemSelectListProps {
    quote: QuoteDto;
    disableAddCustomLineItem?: boolean;
    onAddQuoteLineItem: (quoteLineItem: LineItemDto) => void;
    onAddCustomLineItem: () => void;
}

export const QuoteLineItemSelectList: FC<IQuoteLineItemSelectListProps> = ({ quote, disableAddCustomLineItem, onAddQuoteLineItem, onAddCustomLineItem }) => {

    return (
        <Box sx={{ height: '60vh', overflow: 'auto', width: '100%' }}>
        <QuoteLineItemsOrderView
                quote={quote}
                copyQuoteLineItemToOrder={onAddQuoteLineItem}
                maxHeight={'50vh'} // should be a string with 'px' or 'vh'
                />
            {!disableAddCustomLineItem && 
            <>
                <Divider>
                    OR
                </Divider>
                <Box px={2}>
                    <Button variant='contained' onClick={onAddCustomLineItem} fullWidth disabled={disableAddCustomLineItem}>
                        Add Custom Line Item
                    </Button>
                </Box>
            </>}
        </Box>
    );
};